import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import classNames from 'classnames'
import { sortBy}  from 'lodash'
import moment from 'moment'
import {useVideoRoomEventFor} from "./utils.js"
import { Liquid } from 'liquidjs'
import RenderedHtmlContent from "../../../../virtual_congress/components/rendered_html_content";
import QuestionsUpVoteButton from './questions_upvote_button.jsx'

export default function Questions({videoRoom, event, questionsRepeatNames, questionsShowCompany, showQuestionUpVote, options,...props}) {
  const tagOwner = useSelector(state => state.tagOwner)
  const eventQuestionsFromEvent = useVideoRoomEventFor(videoRoom, videoRoom.take_event_questions_from, options?.overrideEvent)
  const eventQuestions = useSelector(state => state.eventQuestions)
  const filteredEventQuestions = eventQuestions.filter((eq) => eq.event_id == eventQuestionsFromEvent.id  && (options?.showInvisibleQuestions || eq.visible) && !eq.archived)
  
  let getSortField = (question) => { return question[options?.sortField] }
  if (options?.reverse && options?.sortField) {
    // for windhund question sort by upvotes descending
    getSortField = (question) => { return -1 * question[options?.sortField] }
  }

  let questions = sortBy(filteredEventQuestions, (question) => options?.sortField ? getSortField(question): moment(question["created-at"]))
  if (options?.showOnlyOwnQuestions) {
    questions = questions.filter((question) => question.tag_owner_id == tagOwner.id)
  }

  const lastMessage = questions[questions.length - 1]?.created_at;
  const objDiv = document.getElementById("questions");

  useEffect(() => {
    if(objDiv && options?.autoScroll)
      objDiv.scrollTop = objDiv.scrollHeight;
  }, [lastMessage, objDiv, options?.autoScroll])

  if(options?.enabled == false) {
    return null
  }

  if (!questions || questions.length === 0) {
    return null
  }

  let lastName = null;
  
  console.log(questionsShowCompany, options, options?.showNames, options?.showNames == true)

  return <div id="questions" className="questions videoroom-questions">
    {questions.map((question, index) => {
      let content = ""
      if(!question.tag_owner) {
        return null
      } else if (videoRoom.question_liquid != null && videoRoom.question_liquid !== "") {
        content = <RenderedHtmlContent html={videoRoom.question_liquid} placeholders={{ question }} />
      } else {
        content = (
          <div key={"question" + question.id} className={classNames("question-row-container", {moderator: question.tag_owner?.moderator})}>
            <div className="row no-gutters question-row" key={"quest-" + question.title + index}>
              <div className="col question-col">
                <div className="question-container">
                  {options?.showNames &&
                    <>
                      {(questionsRepeatNames || lastName == null || lastName != question.tag_owner.name) &&
                        <small className={classNames("text-muted", "question-author")}>
                          {question.tag_owner.name}
                          {questionsShowCompany && question.tag_owner.company && question.tag_owner.company != "" &&
                            <span className="text-muted question-company">, {question.tag_owner.company}</span>
                          }
                        </small>
                      }
                    </>
                  }
                  <div className="question question-content">{question.body}</div>
                  {question.answer &&
                    <div className="question question-answer">{question.answer}</div>
                  }
                </div>
              </div>
              {showQuestionUpVote && <div className="col-2 col-sm-1 col-lg-2 text-center">
                <QuestionsUpVoteButton videoRoom={videoRoom} question={question}/>
              </div>}
            </div>
          </div>
        )
      }

      lastName = question.tag_owner.name
      return content
    })}
  </div>
}
